
import { useState, useEffect } from 'react';

const quotes = [
  { text: "The beautiful thing about learning is nobody can take it away from you.", author: "B.B. King" },
  { text: "It's not that I'm so smart, it's just that I stay with problems longer.", author: "Albert Einstein" },
  { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
  { text: "Questions are the engines of intellect.", author: "David Hackett Fischer" },
  { text: "Every expert was once a beginner.", author: "Helen Hayes" }
];

export const useAnimatedQuotes = () => {
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        setIsVisible(true);
      }, 800); // Slower fade out duration
    }, 6000); // Change quote every 6 seconds (slower)

    return () => clearInterval(interval);
  }, []);

  return {
    currentQuote: quotes[currentQuoteIndex],
    isVisible
  };
};
